import { createSlice } from '@reduxjs/toolkit';

import UnauthService from 'services/Unauth.service';

import { camelCase, isNil, size, orderBy } from "lodash";

const initialState = {};

const supportSettingSlice = createSlice({
  name: 'supportSetting',
  initialState,
  reducers: {
    cleanAll (state) {
      Object.assign(state, initialState);
    },
    set (state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const fetchSupportSetting = () => {
  return async (dispatch) => {
    const { data } = await UnauthService.getSetting();
    const list = await genCountryList(data.supportedCountries);
    data.countryTimezoneList = list;
    dispatch(supportSettingActions.set(data));
  };
};

const genCountryList = (countries) => {
  return new Promise(async (Resolve, reject) => {
    const map = {}
    countries.forEach((country) => {
      const countryName = camelCase(country.name)
      if (isNil(map[countryName])) map[countryName] = { title: country.name, cities: [] }

      const zoneArr = country.zone.replace(/_/g, ' ').split('/')
      const tmpCity = {
        title: `${zoneArr.join('/')}(UTC${country.timezone}, DST)`, //`${zoneArr.join('/')}(UTC${country.timezone})`
        timezone: country.timezone,
        city: zoneArr[size(zoneArr) - 1],
        enableDST: country.enableDST,
        dsts: country.dsts || null
      }
      map[countryName].cities.push(tmpCity)
    })

    let res = []
    Object.values(map).forEach((item) => {
      item.cities = orderBy(item.cities, 'title', 'asc');
      res.push(item)
    });
    Resolve(orderBy(res, 'title', 'asc'));
  })
}

export const supportSettingActions = supportSettingSlice.actions;

export default supportSettingSlice;